import React from 'react';
import { faPlus, faPrint } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Button } from 'primereact/button';
import { Accordion, AccordionTab } from 'primereact/accordion';

import { ModelOfOrderService } from 'src/database';
import { dateToString } from 'src/utils/dateToString';



interface ServiceCardProps {
  orderService: ModelOfOrderService;
  handleClick: ({ }: any) => void;
  handlePrint: ({ }: any) => void;
}


const OrderServiceCard: React.FC<ServiceCardProps> = ({ orderService, handleClick, handlePrint }) => {
  return (
    <div className="container-row">
      <div className="container">
        <div className="card-header">
          <span>STATUS - Em andamento</span>
        </div>
        <div className="card-body">
          <div className="card-column">
            <div className="card-content">
              <span className="info-title">Veículo</span>
              <span className="info-text">{orderService.DESCRICAO_VEICULO}</span>
            </div>
            <div className="card-content">
              <span className="info-title">Descrição da demanda</span>
              <span className="info-text">{orderService.DESCRICAO_DEMANDA}</span>
            </div>
            <div className="card-content">
              <span className="info-title">Requisitado por</span>
              <span className="info-text">{orderService.NOME_PESSOAORIGEM}</span>
            </div>
            <div className="card-content">
              <span className="info-title">Unidade</span>
              <span className="info-text">{orderService.NOME_ORGAOUNIDADEDESTINO}</span>
            </div>
            <div className="button-container">
              <Button className="button" onClick={handleClick}>
                <FontAwesomeIcon icon={faPlus} />
                <span className="p-ml-2"> Editar ordem de serviço</span>
              </Button>
              <Button
                className="button p-ml-2" // p-ml-2 adiciona um pequeno espaçamento à esquerda
                onClick={() => {
                  // Aqui você chama a função para imprimir
                  handlePrint(orderService);
                }}
              >
                <FontAwesomeIcon icon={faPrint} /> {/* ícone de impressora */}
                <span className="p-ml-2">Imprimir</span>
              </Button>
            </div>
          </div>

          <div className="card-column">
            <div className="card-content">
              <span className="info-title">Placa</span>
              <span className="info-text">{orderService.PLACA_VEICULO}</span>
            </div>
            <div className="card-content">
              <span className="info-title">Data</span>
              <span className="info-text">{dateToString(orderService.DATA_DEMANDA, 'br')}</span>
            </div>
            <div className="card-content">
              <span className="info-title">Órgão</span>
              <span className="info-text">{orderService.NOME_ORGAO}</span>
            </div>
            <div className="card-content">
              <span className="info-title">Manutenção</span>
              <span className="info-text">{orderService.DESCRICAO_TIPOORDEMSERVICO}</span>
            </div>
          </div>
        </div>

        <div className="card-footer">
          <Accordion className="footer-accordion">
            <AccordionTab headerClassName="footer-accordion" header="Produtos utilizados / Serviços realizados ">
              <div className="footer-column">
                <h5>Produtos</h5>
                {orderService.PRODUTOS.map((service: any) => {
                  return (
                    <div className="footer-content" key={service.ID} >
                      <div className="footer-column">
                        <span className="info-title">Produto</span>
                        <span className="info-text" >{service.DESCRICAO_PRODUTO}</span>
                      </div>
                      <div className="footer-column">
                        <span className="info-title">Quantidade</span>
                        <span className="info-text" >{service.QUANTIDADE_PRODUTO}</span>
                      </div>
                      <div className="footer-column">
                        <span className="info-title">Valor Unitário</span>
                        <span className="info-text" >R$ {Number((service.VALOR_PRODUTO).toFixed(2))}</span>
                      </div>
                      <div className="footer-column">
                        <span className="info-title">Valor total</span>
                        <span className="info-text" >R$ {Number((service.VALOR_PRODUTO * service.QUANTIDADE_PRODUTO).toFixed(2))}</span>
                      </div>
                    </div>
                  )
                })}
              </div>

              <div className="footer-column">
                <h5>Serviços</h5>
                {orderService.SERVICOS.map((service: any) => {
                  return (
                    <div className="footer-content" key={service.ID} >
                      <div className="footer-column">
                        <span className="info-title">Serviço</span>
                        <span className="info-text" >{service.DESCRICAO_SERVICO}</span>
                      </div>
                      <div className="footer-column">
                        <span className="info-title">Quantidade</span>
                        <span className="info-text" >{service.QUANTIDADE_SERVICO}</span>
                      </div>
                      <div className="footer-column">
                        <span className="info-title">Valor Unitário</span>
                        <span className="info-text" >R$ {Number((service.VALOR_SERVICO).toFixed(2))}</span>
                      </div>
                      <div className="footer-column">
                        <span className="info-title">Valor total</span>
                        <span className="info-text" >R$ {Number((service.VALOR_SERVICO * service.QUANTIDADE_SERVICO).toFixed(2))}</span>
                      </div>
                    </div>
                  )
                })}
              </div>
            </AccordionTab>
          </Accordion>
        </div>
      </div>
    </div>
  );
};

export default OrderServiceCard;